<template>
  <div
    class="specificity"
    ref="specificity"
    :style="{
    width:`calc(100%/${len}.25)` ,
    backgroundColor : this.realSelected ? this.selectedBackgroundColor : this.unselectedBackgroundcolor ,
    color : this.realSelected ? '#fff' : '#000'
    }"
     @mouseenter="handleMouseEnter"
     @mouseleave="handleMouseLeave"
     @click="handleClick(specificity)"
  >
      {{specificity}}
  </div>
</template>

<script>
  import { mapGetters , mapState , mapActions , mapMutations } from 'vuex'

  export default {
    name: "specificity-item",
    props : ['specificity' , 'index' , 'len'] ,
    computed : {
      ...mapState('contactUsStore' , ['selectedSpecificity']) ,
    },
    watch : {
      selectedSpecificity () {
        this.realSelected = this.selectedSpecificity === this.specificity;
      }
    },
    updated () {
      //console.log('ddfdfdf');
    },
    created () {
      //const selectedCheck = this.selectedSpecificity === this.specificity;
      //this._selected = this.selectedSpecificity === this.specificity;
      this.realSelected = this.selectedSpecificity === this.specificity;

    },
    data () {
      return {
        selectedBackgroundColor : '#96d7e8' ,
        unselectedBackgroundcolor : '#fff' ,
        realSelected : false,
      }
    },
    methods : {
      handleMouseEnter (evt) {
        if(!this.realSelected) {
         this.$refs.specificity.style.backgroundColor = this.selectedBackgroundColor;
         this.$refs.specificity.style.color = '#fff';
        }
      },
      handleMouseLeave (evt) {
        if(!this.realSelected) {
          this.$refs.specificity.style.backgroundColor = this.unselectedBackgroundcolor;
          this.$refs.specificity.style.color = '#000';
        }

      },
      handleClick (value) {
        //console.log(value);
        this.SET__SELECTED__SPECIFICITY(value);
        //this.selected = ;
      },
      ...mapMutations('contactUsStore' , ['SET__SELECTED__SPECIFICITY']),
    }

  }
</script>

<style scoped lang="scss">
  .specificity{
    display: flex;
    justify-content: center;
    align-items: center;
    height:130px;
    text-align: center;
    background-color: #fff;
    margin-right:1rem;
    cursor:pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/menu/ContactUs/SpecificityItem.vue